
import * as React from 'react';
import VideoPalyer from './VideoPlayer';
import AudioPlayer from './AudioPlayer';
import MediaList from './List';

export { default as Video} from './VideoPlayer';
export { default as Audio} from './AudioPlayer';


// export default class Demo extends React.Component {
//   componentDidMount() {

//     var myPlayer = window.videojs('example-video', { 
//       "width":"400",
//       "height":"400",
//       "poster": "",
//       "controls": true,
//       "autoplay" : false,
//       // "techOrder" : [ "html5" ],
//       "loop":false,
//       "muted":false,
//       "preload": 'metadata'
//     }, function onPlayerReady() {
//       // window.videojs.log('Your player is ready!');

//       // In this context, `this` is the player that was created by Video.js.
//       // this.play();
//     });
//   }

//   render() {
//     return (
//       <video id="example-video" playsInline className="video-js vjs-default-skin vjs-big-play-centered">
            	
//       <source src="https://gt-backup-bs-public.oss-cn-shanghai.aliyuncs.com/video_20210929_150109.mp4?OSSAccessKeyId=LTAI4FtcPTACrXykKuErVkrM&Expires=1637630371&Signature=ZDE%2F0A%2Bj221amatbIZ49phW5qZE%3D" type="video/mp4" />
//         </video>
//     )
//   }
// }

export default class Media extends React.Component {

  state = {
    audioData: [{
      sourceURL: 'http://192.168.10.45:9000/dnf.mp3', // 资源地址
      duration: 70, // 持续时间
      id: 1,
      showDelete: true,
    }, {
      sourceURL: 'http://192.168.10.45:9000/dnf.mp3', // 资源地址
      duration: 70, // 持续时间
      id: 2,
      showDelete: false,
    }],

    videoData: [{
      sourceURL: 'https://gt-backup-bs-public.oss-cn-shanghai.aliyuncs.com/video_20210929_150109.mp4?OSSAccessKeyId=LTAI4FtcPTACrXykKuErVkrM&Expires=1637630371&Signature=ZDE%2F0A%2Bj221amatbIZ49phW5qZE%3D', // 资源地址
      sourceImage: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F0170f15d45450ea8012187f43674bf.jpg%402o.jpg&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636609946&t=ff6768045fe59cd99e089d771bb06eab', // 持续时间
      id: 1,
      showDelete: false,
    }, {
      // sourceURL: 'https://gt-backup-bs-public.oss-cn-shanghai.aliyuncs.com/video_20210929_150109.mp4?OSSAccessKeyId=LTAI4FtcPTACrXykKuErVkrM&Expires=1633015893&Signature=G241oX5X5dFvxL7jrG9U8MyKsqw%3D', // 资源地址
      sourceImage: 'http://t13.baidu.com/it/u=3565727147,2722911587&fm=224&app=112&f=GIF?w=357&h=500&s=ED506F974100F2E14EF0B4CE03001021', // 持续时间
      id: 2,
      showDelete: false,
    }, {
      // sourceURL: 'https://gt-backup-bs-public.oss-cn-shanghai.aliyuncs.com/video_20210929_150109.mp4?OSSAccessKeyId=LTAI4FtcPTACrXykKuErVkrM&Expires=1633015893&Signature=G241oX5X5dFvxL7jrG9U8MyKsqw%3D', // 资源地址
      sourceImage: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.faloo.com%2FNovelNode%2F0x0%2F1%2F1111%2F1111212.gif&refer=http%3A%2F%2Fimg.faloo.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636683345&t=54866a391473c094b29715eec4d49169', // 持续时间
      id: 3,
      showDelete: false,
    }, {
      sourceURL: 'https://gt-backup-bs-public.oss-cn-shanghai.aliyuncs.com/video_20210929_150109.mp4?OSSAccessKeyId=LTAI4FtcPTACrXykKuErVkrM&Expires=1633015893&Signature=G241oX5X5dFvxL7jrG9U8MyKsqw%3D', // 资源地址
      sourceImage: 'https://img0.baidu.com/it/u=1293847201,1232859076&fm=26&fmt=auto', // 持续时间
      id: 4,
      showDelete: false,
    }]
  }

  onAudioDelete = (id) => {
    let { audioData } = this.state;
    audioData = audioData.filter((item) => item.id !== id);
    this.setState({ audioData });
  }

  onVideoDelete = (id) => {
    let { videoData } = this.state;
    videoData = videoData.filter((item) => item.id !== id);
    this.setState({ videoData });
  }

  render() {
    return (
      <div>
        <h2>音频使用</h2>
        {this.state.audioData.map((item) => {
          return (
            <AudioPlayer
              key={item.id}
              gutter={[8, 8]} // 上下间距
              sourceURL={item.sourceURL}
              showDelete={item.showDelete} // 是否显示删除按钮
              onDelete={(e) => this.onAudioDelete(item.id)} // 删除事件
            />
          );
        })}
        <h2>视频混合图片在显示式使用</h2>
        <MediaList>
          {this.state.videoData.map((item) => {
            return (
              <VideoPalyer
                width={90}
                height={90}
                gutter={[4, 4]} // 上下左右间距
                key={item.id}
                sourceURL={item.sourceURL}
                sourceImage={item.sourceImage}
                showDelete={item.showDelete} // 是否显示删除按钮
                onDelete={(e) => this.onVideoDelete(item.id)} // 删除事件
              />
            );
          })}
        </MediaList>
        <h2>视频在编辑页面</h2>
        <MediaList>
          {this.state.videoData.map((item) => {
              return (
                <VideoPalyer
                  width={60}
                  height={60}
                  gutter={[4, 4]} // 上下左右间距
                  key={item.id}
                  sourceURL={item.sourceURL}
                  sourceImage={item.sourceImage}
                  showDelete // 是否显示删除按钮
                  onDelete={(e) => this.onVideoDelete(item.id)} // 删除事件
                />
              );
          })}
        </MediaList>
      </div>
    );
  }
}